import AuthUtils from '@/utils/auth'

export default {
    computed: {
        auth() {
            return {
                user: this.$store.state.user,
                loggedIn: !!this.$store.state.user,
            }
        }
    },
    methods: {
        hasRole(role) {
            return AuthUtils.hasRole(role);
        },
        hasDealerOrManagerRole() {
            return AuthUtils.hasDealerOrManagerRole();
        }
    }
}
